import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomDataField from "../data-inputs/custom-data-field.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CustomDataFieldsForm",
  components: {
    CustomDataField
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    customFieldsDefinitions: {
      type: Object,
      default: () => ({})
    },
    pageName: {
      type: String,
      default: "clientProfile"
    },
    translationMap: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      deletingWords: {
        clientProfile: {
          element: this.$tc("global.doorr.clientProfile", 1)
        },
        referrers: {
          element: this.$tc("global.doorr.referrer", 1)
        }
      }
    };
  },
  computed: {
    customFields: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("change", value);
      }
    },
    firstOrphanIndex() {
      var _context;
      return _findIndexInstanceProperty(_context = this.customFields).call(_context, ({
        orphaned
      }) => orphaned);
    }
  },
  methods: {
    handleChange(index, value) {
      this.customFields[index] = value;
      this.customFields = [...this.customFields]; //trigger reactivity
      this.$nextTick(() => {
        if (this.isValidChange()) this.$emit("submit");
      });
    },
    isValidChange(index) {
      const {
        customDataFieldElement
      } = this.$refs;
      if (index === 0 && !Array.isArray(customDataFieldElement)) return customDataFieldElement.isValidWithWarnings;
      return customDataFieldElement.every(element => element.isValidWithWarnings);
    },
    getCustomFieldDefinition(id) {
      var _this$customFieldsDef;
      return (_this$customFieldsDef = this.customFieldsDefinitions[id]) != null ? _this$customFieldsDef : {};
    },
    getElementName() {
      return this.deletingWords[this.pageName].element;
    },
    getFieldName(field) {
      return {
        label: this.$options.filters.getSchemaTranslation(field.name, this.translationMap),
        key: field.name
      };
    }
  }
});